<template>
<div  class="container-fluid" >
  
 
  
  
  <div class="card">
  
  <div class="card-header text-white bg-primary">    
      
    <h4><i  class="fas fa-clipboard-check mr-2" aria-hidden="true"></i>ESPOSIZIONE COLORE MATCHING</h4>    
  </div>
  

  <div  class="card-body"> 
   <p style="color:red;font-size:18px" v-if="items.length>0" class="text-center "><strong>
      <i class="fas fa-barcode mr-2" aria-hidden="true"></i>
     PRONTO ALLA SCANSIONE</strong></p>  

    <div class="row">
    <div class="col-2"> 

   <div class="card border-info">
   <div class="card-header bg-info"><strong>PARAMETRI DI RICERCA</strong></div>
   <div class="card-body text-black">



  <form name="productSearch" v-on:submit.prevent="getData()">

   
      
      <div class="form-group">                
        <supplier-select  v-bind:optionBase="true"  v-bind:Id="0" v-bind:isActive="true" @update="setSupplierId"></supplier-select>
      </div>

   

    
    

    <!-- GROUP CATEGORY -->
    
        <div class="form-group">
            <category-grouping v-bind:optionBase="true" v-bind:isActive="true" @update="setGroupCategoryId"></category-grouping>  
        </div>
   



   
        <div class="form-group">
            <department-select v-bind:type="true" v-bind:optionBase="true" v-bind:isActive="true" @update="setDepartmentId"></department-select>  
        </div>
   

   
        <div class="form-group">
            <season-select v-bind:Id="0" v-bind:type="true" v-bind:optionBase="true" v-bind:isActive="true" @update="setSeasonId"></season-select>      
        </div>
   

   
        <div class="form-group">
         <year-select  v-bind:_year="0" v-bind:optionBase="true" v-bind:isActive="true" @update="setYear"></year-select>      
        </div>  

      
   
  
  
  <div class="card-footer bg-transparent border-info"> 
    <button  class="btn btn-primary active float-right">
       <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
      CERCA
      <span v-if="spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
      </button>
  </div>
  

  </form>

  </div>
  </div>
  </div>

  <div class="col-10">
    <alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>
    <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">

  <table class="table table-hover table-striped table-sm mb-0">
    <thead >
      <tr class="table-primary">
       
        <th scope="col">#</th>
        <th scope="col">ID</th>
        <th scope="col">BRAND</th>
        <th scope="col">CATEGORIA</th>
        
        <th scope="col">CODICE</th>
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
     
        <th scope="col">COLORE</th>
        

        <th class="text-right" scope="col">QTA' STOCK</th>
        <th class="text-right" scope="col">QTA' MATCH</th>
        
       
      </tr>
    </thead>
    <tbody>
      
      <tr  v-for="(item, index) in items" :key="index">
       
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.category}}</td>        
        <td><strong>{{item.sku}}</strong></td>
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td>{{item.color}} </td>
       
        
        <td class="text-right"><strong>{{item.qty}}</strong></td>
        <td v-bind:style="{color: item.match_qty != item.qty ? 'red':'black'}" class="text-right"><strong>{{item.match_qty}}</strong></td>
        

       
      </tr> 
      
      
    </tbody>
    <tfoot>
        <tr> 
        <td></td>        
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>        
        <td></td>                
        

        <td></td>
        <td class="text-right"> {{total1}}</td>
        <td class="text-right"> {{total2}}</td>
        
        </tr>   
    </tfoot>    
  </table>
  

    
  
  </div>

  


  </div>  


  </div>


  
  


  </div>


</div>


<button  @click="set_sandBox()"  class="btn btn-outline-secondary mt-2 ml-2 mr-3">
   <i  class="far fa-copy mr-2" aria-hidden="true"></i>
   SOSPENDI OPERAZIONI
</button>
<button  @click="get_sandBox()"  class="btn btn-outline-secondary  mt-2">
   <i  class="fas fa-paste mr-2" aria-hidden="true"></i>
   RIPRENDI OPERAZIONI
</button>

 

<!--
<div class="row float-right">
<button @click="check()" class="btn btn-success  mr-4 mt-3">
<i class="fas fa-check mr-2" aria-hidden="true"></i>
  VERIFICA
  
</button>
 </div>
-->

</div>



</template>
<script>
import scannerDetection    from '@/scanner';  
import api                 from "@/api";

import alertBox          from '@/components/common/AlertBox.vue'

import supplierSelect    from '@/components/common/SupplierSelect.vue';
import categoryGrouping  from '@/components/common/CategoryGroupingSelect.vue';
//import categorySelect    from './../../components/common/CategorySelect.vue';
import departmentSelect  from '@/components/common/DepartmentSelect.vue';
import seasonSelect      from '@/components/common/SeasonSelect.vue';
import yearSelect        from '@/components/common/YearSelect.vue';


import {mapGetters }    from 'vuex';
export default {
   //props      : ['route'],
  components  : {alertBox,supplierSelect,categoryGrouping,departmentSelect,seasonSelect,yearSelect},
  data() {
    return {
    
    product                : {},
    items                  : [],
    msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
    spinner                : false,     
    total1                 : 0,
    total2                 : 0,
      
    
     
    }
  },
  computed :{
   
     ...mapGetters(['company','storeId']),
    
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },
   mounted : function()
  {
  
    $(document).scannerDetection(data => 
    {
      onReceive:
      this.msg.title = ''
      if(this.items.length==0)
      {
        this.msg.title = "ATTENZIONE "
        this.msg.body  = "Selezionare un campione di prodotti."
        this.msg.type  = 1
        
        return
      }

      onComplete:
      if (data.length == 13)
      { 

        this.setMatch(data)

      };       
    });
    
  },
  beforeDestroy () {
   
  
        $(document).scannerDetection(false);
    },
  

  created: function() {
    


  },
  methods: {
    set_sandBox()
    {
      
       
      
      if(this.items.length > 0)
      {
       
        localStorage.setItem('product_stock_matching',JSON.stringify(this.items))
        this.items = []


      }
        
    },
    get_sandBox()
    {
        var items = JSON.parse(localStorage.getItem('product_stock_matching'))
        if(items)
        {
         
            
          this.items = items
          
        }
        
    },

    
    setTotal2 : function()
    {
       let total= 0
       this.items.forEach(item=>
          total += Number(item.match_qty)
       )
       this.total2 = total
    },
    setMatch(barcode)
    {
      let flag = 0
      let barcodes = []
      this.items.forEach(item=>
      {
          let barcodes  = item.barcodes.split(',')
          
          barcodes.forEach(el =>{
              if(barcode==el)
              {
                item.match_qty = 1
                this.setTotal2()  
                flag++
                
              }
          })
      })
      

      //let arr = this.items.filter(item => item.productId ==  )
      
      if(flag==0)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Articolo non presente sul campione prodotti.'
        this.msg.type = 1
        return
      }
      
    },  
    setSupplierId(Id)
    {
      
        this.product.SupplierId = Id
    },
    setGroupCategoryId(Id)
    {
      
        this.product.GroupCategoryId = Id
    },
    setCategoryId(Id)
    {
      
        this.product.CategoryId = Id
    },
    setDepartmentId(Id)
    {
      
        this.product.DepartmentId = Id
    },
    setSeasonId(Id)
    {
      
        this.product.SeasonId = Id
    },
    setYear(year)
    {
        this.product.SeasonYear = year
    },

    async getData() {
    
  
      this.msg.title = ''

      var params = 0
      for (const [key, value] of Object.entries(this.product)) {
           params += Number(value)
      }
      
      if(params < 4 )
      {
          this.msg.title = 'ATTENZIONE '
          this.msg.body  = 'Compilare almeno quattro criteri di ricerca.'
          this.msg.type  = 1
          
          return
      }
      
      this.total = 0
      this.spinner = true
      this.items   = []
      
      var data     = {
      'companyId'    : this.company.Id,
      'storeId'      : this.storeId,     
      'seasonId'     : this.product.SeasonId,
      'departmentId' : this.product.DepartmentId,
      'year'         : this.product.SeasonYear,
      'grpcategory'  : this.product.GroupCategoryId,
      'supplierId'   : this.product.SupplierId

      } 
     
      var sp = {'sp':'spStoreProductColorMatching'}
      var json    = Object.assign(data, sp)
         await api.post(json).then(res => {
          
          
          
          if(res.status==200)
            {
              

              this.items     = res.data.recordsets[0]
              
              

              this.total1 = 0
              this.items.forEach(item=>{
                this.total1 += item.qty
              })
              

              if(res.data.recordsets[0].length==0)
              { 
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = 'DATI INESISTENTI.'
              this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1
              
            }
          
          else
          {

            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.spinner = false
      






     



    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 600px;
overflow: auto;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;


    background   : hwb(45 4% 9%);  
    color        : black;   

    background   : #5c8fb1;
    color        : black;
    
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 18px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}

.card-header
{
  height: 45px;
}
</style>